/**
 * MCP API key management client (/api/mcp/keys).
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

async function authedFetch(endpoint, options = {}) {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');
  const response = await fetch(buildApiUrl(endpoint), {
    ...options,
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders(idToken), ...(options.headers || {}) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.message || body.error || `Request failed: ${response.statusText}`);
    error.status = response.status;
    throw error;
  }
  return body;
}

/** { keys: [...], mcpUrl } */
export const fetchMcpKeys = () => authedFetch('/mcp/keys');

/** { secret, key, mcpUrl } — the secret is only ever in this response. */
export const createMcpKey = (label) => authedFetch('/mcp/keys', { method: 'POST', body: JSON.stringify({ label }) });

export const revokeMcpKey = (keyHash) => authedFetch(`/mcp/keys/${encodeURIComponent(keyHash)}`, { method: 'DELETE' });
